<app-header></app-header>

<ion-content class="ion-no-padding" *ngIf="showAll">
  <app-space-add-reservation
    [spaceType]="spaceType"
    [events]="eventsSubject.asObservable()"
  ></app-space-add-reservation>
</ion-content>
